import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, CSSProperties } from "vue";
import type { PropType } from "@vue/runtime-core";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseIcon',
  props: {
  name: {
    type: String,
    required: true,
  },
  position: {
    type: String as PropType<"left" | "right" | "bottom" | "top">,
    default: "right",
  },
  folder: {
    type: String,
    default: "ui",
  },
  isOriginalColor: {
    type: Boolean,
    default: false,
  },
  isGradient: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;
const maskStyles = computed<CSSProperties>(() => {
  const url = `/img/base-icons/${props.folder ? props.folder + "/" : ""}${
    props.name
  }.svg`;
  if (props.isOriginalColor)
    return {
      background: `url(${url}) no-repeat center / contain`,
    };
  else
    return {
      mask: `url(${url}) no-repeat center / contain`,
      "-webkit-mask": `url(${url}) no-repeat center / contain`,
    };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-icon", [`--${props.position}`, { '--gradient': __props.isGradient }]])
  }, [
    _createElementVNode("div", {
      class: "base-icon-mask",
      style: _normalizeStyle([maskStyles.value])
    }, null, 4)
  ], 2))
}
}

})